import { render, staticRenderFns } from "./RepairRegistrationReport.vue?vue&type=template&id=afdb9e94&scoped=true"
import script from "./RepairRegistrationReport.vue?vue&type=script&lang=js"
export * from "./RepairRegistrationReport.vue?vue&type=script&lang=js"
import style0 from "./RepairRegistrationReport.vue?vue&type=style&index=0&id=afdb9e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb9e94",
  null
  
)

export default component.exports